enum LOBType {
  HOTEL_SEARCH = 1,
  HOTEL_DETAIL = 2,
  FLIGHTS = 3,
  PACKAGES = 4,
}

export { LOBType };
